<template>
  <div>
<v-dialog v-model="dialogDocumentos" scrollable max-width="700px">
            <v-card class="premium-card overflow-hidden">
                <v-toolbar dark color="primary">
                    <v-icon large class="mr-3">attachment</v-icon>
                    <v-toolbar-title class="headline font-weight-bold">
                        Documentos Adjuntos
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="white"
                            flat
                            icon
                            @click="dialogDocumentos = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-4">
                    <v-layout column>
                        <template v-for="(doc, key) in missingDocumentations">
                            <v-card flat :key="`preview-${key}`" class="premium-shipment-card pa-3 mb-3">
                                <!-- Primera Fila: Icono y Nombre -->
                                <v-layout align-center row wrap>
                                    <v-flex xs2 sm1 class="text-xs-center">
                                        <v-avatar color="primary lighten-5" size="40">
                                            <v-icon color="primary">description</v-icon>
                                        </v-avatar>
                                    </v-flex>
                                    <v-flex xs10 sm11>
                                        <div class="subheading font-weight-bold primary--text ml-2">{{ doc.name }}</div>
                                    </v-flex>
                                </v-layout>

                                <v-divider class="my-2" style="border-style: dashed; border-color: #e3f2fd;"></v-divider>

                                <!-- Segunda Fila: Mensaje y Botón -->
                                <v-layout align-center row wrap>
                                    <v-flex xs7 sm8>
                                        <div v-if="doc.file" class="caption success--text font-weight-medium ml-2">
                                            <v-icon x-small color="success" class="mr-1">check_circle</v-icon> Archivo adjunto
                                        </div>
                                        <div v-else class="caption error--text font-weight-medium ml-2">
                                            <v-icon x-small color="error" class="mr-1">warning</v-icon> No se adjuntó
                                        </div>
                                    </v-flex>
                                    <v-flex xs5 sm4 class="text-xs-right">
                                        <v-btn
                                            small
                                            depressed
                                            color="primary"
                                            class="rounded-btn ma-0"
                                            @click="openDialog(doc.file)"
                                            :disabled="!doc.file"
                                        >
                                            <v-icon left small>visibility</v-icon>
                                            Visualizar
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </template>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
<v-dialog v-model="dialogShowDocument" max-width="1000px">
            <v-card class="premium-card overflow-hidden">
                <v-toolbar dark color="primary">
                    <v-icon large class="mr-3">visibility</v-icon>
                    <v-toolbar-title class="headline font-weight-bold">Visualizador de Archivo</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <!-- Botón Cerrar -->
                    <v-btn color="white" flat icon @click="dialogShowDocument = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text>
                <!-- PDF -->
                <div v-if="isPdf" style="height: 80vh;">
                    <iframe
                    :src="fileUrl"
                    width="100%"
                    height="100%"
                    frameborder="0"
                    ></iframe>
                </div>

                <!-- Imagen -->
                <div v-else style="text-align: center;">
                    <img
                    :src="fileUrl"
                    alt="Imagen"
                    style="max-width: 100%; max-height: 80vh; border-radius: 8px;"
                    />
                </div>
                </v-card-text>
            </v-card>
        </v-dialog>
<v-dialog v-model="dialog_img" max-width="800px">
            <v-card>
                <v-card-text class="pa-0">
                    <v-img :src="img_src" contain width="100%"></v-img>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary" @click="dialog_img = false">{{$t('cerrar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

<!-- Modal Pesada de Entrada (CAV) -->
<v-dialog v-model="dialogWeighIn" persistent max-width="900px">
    <ScaleWeighing
        v-if="dialogWeighIn && isCavActive && getProfile.roll === 9"
        :modo="'ENTRADA'"
        :info-invitation="info_invitation"
        :pre-filled-data="formWeighIn"
        :is-entrada="true"
        @save="onWeighInSave"
    />
</v-dialog>

<!-- Modal Pesada de Salida (CAV) -->
<v-dialog v-model="dialogWeighOut" persistent max-width="900px">
    <ScaleWeighing
        v-if="dialogWeighOut && isCavActive && getProfile.roll === 9"
        :modo="'SALIDA'"
        :info-invitation="info_invitation"
        :pre-filled-data="formWeighOut"
        :is-entrada="false"
        @save="onWeighOutSave"
    />
</v-dialog>

<v-dialog v-model="dialogWaitingRoom" max-width="500px">
            <v-card class="premium-card">
                <v-toolbar dark color="primary">
                    <v-icon large class="mr-3">hourglass_empty</v-icon>
                    <v-toolbar-title class="headline font-weight-bold">Enviar a Sala de Espera</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="white" flat icon @click="dialogWaitingRoom = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <p class="subheading">Por favor ingresa el motivo para enviar al conductor a la sala de espera:</p>
                    <v-textarea
                        v-model="waitingRoomReason"
                        label="Motivo"
                        outlined
                        auto-grow
                        rows="3"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions class="pa-3 bg-muted">
                    <v-spacer></v-spacer>
                    <v-btn flat @click="dialogWaitingRoom = false">Cancelar</v-btn>
                    <v-btn color="primary" class="rounded-btn" :loading="loadingWaitingRoom" :disabled="!waitingRoomReason" @click="send_to_waiting_room">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
<v-dialog v-model="dialog_errores"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    <h3 class="text-xs-center white-space-pre-wrap">{{errores_guard}}</h3>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <v-btn
                            v-if="isCavActive && cav_print_url"
                            color="info"
                            x-small
                            :loading="loading"
                            @click="openCavPrintUrl"
                    >
                        <v-icon left small>print</v-icon>
                        Imprimir CAV
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="closeAfterAccess"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
<v-dialog v-model="dialog" persistent scrollable max-width="1200px">
            <v-card v-if="entrada" class="premium-card overflow-hidden">
                <v-toolbar dark color="primary">
                    <v-icon large class="mr-3">local_shipping</v-icon>
                    <v-toolbar-title class="headline font-weight-bold">{{$t('info_shipment')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="white"
                            flat
                            icon
                            @click="closeModal">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text v-if="info_invitation" class="pa-0">
                    <v-container grid-list-md>
                        <v-layout row wrap>
                            <!-- Section 1: Shipment Details (EMPHASIZED) -->
                            <v-flex xs12>
                                <v-card flat class="premium-shipment-card rounded-card pa-4 mb-3">
                                    <div class="d-flex align-center mb-4">
                                        <v-icon large color="primary" class="mr-3">local_shipping</v-icon>
                                        <div>
                                            <h3 class="headline primary--text font-weight-bold">{{$t('shipment_details')}}</h3>
                                            <div class="caption grey--text text-uppercase font-weight-medium tracking-wider">Información logística del embarque</div>
                                        </div>
                                        <v-spacer></v-spacer>
                                        <div class="text-xs-right">
                                            <v-chip v-if="info_invitation.confirmed" color="success" outline small label class="font-weight-bold">{{$t('confirmed')}}</v-chip>
                                            <v-chip v-if="!info_invitation.confirmed" color="error" outline small label class="font-weight-bold">{{$t('not_confirmed')}}</v-chip>
                                            <v-chip v-if="info_invitation.supervisor_authorization" color="primary" outline small label class="font-weight-bold">{{$t('authorized')}}</v-chip>
                                            <v-chip v-if="info_invitation.canceled" color="error" outline small label class="font-weight-bold">{{$t('canceled')}}</v-chip>
                                            <v-chip v-if="info_invitation.window_status === 'SALA_ESPERA'" color="warning" outline small label class="font-weight-bold">SALA DE ESPERA</v-chip>
                                            <v-chip v-if="info_invitation.arrival_registered" color="info" outline small label class="font-weight-bold">{{$t('arrival_registered')}}</v-chip>
                                        </div>
                                    </div>
                                    
                                    <v-divider class="mb-4"></v-divider>

                                    <v-layout row wrap>
                                        <!-- Column 1: Schedule -->
                                        <v-flex xs12 md4>
                                            <div class="d-flex align-start">
                                                <v-avatar tile color="primary lighten-5" size="48" class="mr-3">
                                                    <v-icon color="primary">event</v-icon>
                                                </v-avatar>
                                                <div>
                                                    <div class="caption blue-grey--text font-weight-bold text-uppercase">{{$t('fecha_hora')}}</div>
                                                    <div class="title font-weight-black primary--text">{{ info_invitation.window_date.split('-').join('/') }}</div>
                                                    <div class="subheading font-weight-bold grey--text">{{ info_invitation.window_time }}</div>
                                                </div>
                                            </div>
                                        </v-flex>

                                        <!-- Column 2: Location -->
                                        <v-flex xs12 md4>
                                            <div class="d-flex align-start">
                                                <v-avatar tile color="primary lighten-5" size="48" class="mr-3">
                                                    <v-icon color="primary">location_on</v-icon>
                                                </v-avatar>
                                                <div>
                                                    <div class="caption blue-grey--text font-weight-bold text-uppercase">{{$t('loading_area')}}</div>
                                                    <div class="title font-weight-bold">{{ info_invitation.loading_area_name }}</div>
                                                    <div class="caption grey--text">{{ info_invitation.loading_area_type }}</div>
                                                </div>
                                            </div>
                                        </v-flex>

                                        <!-- Column 3: Business -->
                                        <v-flex xs12 md4>
                                            <div class="d-flex align-start">
                                                <v-avatar tile color="primary lighten-5" size="48" class="mr-3">
                                                    <v-icon color="primary">business</v-icon>
                                                </v-avatar>
                                                <div style="width: 100%;">
                                                    <div class="caption blue-grey--text font-weight-bold text-uppercase">{{$t('client_label')}}</div>
                                                    <div v-if="info_invitation.clients_count && info_invitation.clients_count > 1">
                                                        <div v-if="info_invitation.clients_detail" class="title font-weight-bold">
                                                            {{ info_invitation.clients_detail.map(c => c.name || c.code).join(', ') }}
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="title font-weight-bold">{{ info_invitation.client_name }}</div>
                                                        <div class="caption grey--text">{{ info_invitation.client_code }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row wrap class="mt-4">
                                        <v-flex xs12 md4>
                                            <div class="d-flex align-start">
                                                <v-avatar tile color="primary lighten-5" size="48" class="mr-3">
                                                    <v-icon color="primary">local_shipping</v-icon>
                                                </v-avatar>
                                                <div>
                                                    <div class="caption blue-grey--text font-weight-bold text-uppercase">{{$t('transport_type')}}</div>
                                                    <div class="subheading font-weight-bold">{{ info_invitation.transport_type || 'N/A' }}</div>
                                                </div>
                                            </div>
                                        </v-flex>
                                        <v-flex xs12 md8>
                                            <div class="blue-grey lighten-5 rounded-card pa-3 fill-height">
                                                <div class="caption blue-grey--text font-weight-bold text-uppercase">{{$t('Notas')}}</div>
                                                <div class="body-1 italic">{{ info_invitation.observations || 'Sin observaciones' }}</div>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-flex>

                            <!-- Section 2: Guest (Conductor) & Docs -->
                            <v-flex xs12 md6>
                                <v-card flat class="blue-grey lighten-5 rounded-card pa-3 fill-height">
                                    <h3 class="subheading primary--text font-weight-bold text-xs-center mb-3">{{$t('info_conductor')}}</h3>
                                    <v-layout align-center column class="mb-3">
                                        <v-avatar size="120" class="elevation-4 avatar-border mb-3">
                                            <v-img :src="info_invitation.guest_avatar || 'https://via.placeholder.com/120'"></v-img>
                                        </v-avatar>
                                        <div class="text-xs-center">
                                            <div class="title font-weight-bold">{{ info_invitation.guest_first_name }} {{ info_invitation.guest_last_name }}</div>
                                            <div class="subheading grey--text"><v-icon small class="mr-1">phone_iphone</v-icon>{{ info_invitation.guest_phone }}</div>
                                        </div>
                                    </v-layout>

                                    <v-divider class="my-3"></v-divider>
                                    
                                    <div class="caption font-weight-bold blue-grey--text mb-2">{{$t('identification_documents')}}</div>
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <v-card flat class="transparent" @click="openImage(info_invitation.guest_id_front)">
                                                <v-img :src="info_invitation.guest_id_front || ''" aspect-ratio="1.6" class="rounded-card grey lighten-3 cursor-pointer">
                                                    <template v-slot:placeholder>
                                                        <v-layout fill-height align-center justify-center ma-0>
                                                            <v-icon large color="grey">account_box</v-icon>
                                                        </v-layout>
                                                    </template>
                                                </v-img>
                                                <div class="caption text-xs-center mt-1">Frente</div>
                                            </v-card>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-card flat class="transparent" @click="openImage(info_invitation.guest_id_back)">
                                                <v-img :src="info_invitation.guest_id_back || ''" aspect-ratio="1.6" class="rounded-card grey lighten-3 cursor-pointer">
                                                    <template v-slot:placeholder>
                                                        <v-layout fill-height align-center justify-center ma-0>
                                                            <v-icon large color="grey">account_box</v-icon>
                                                        </v-layout>
                                                    </template>
                                                </v-img>
                                                <div class="caption text-xs-center mt-1">Reverso</div>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>
                                    <v-btn
                                        large
                                        depressed
                                        block
                                        class="rounded-btn mt-3 premium-btn-primary"
                                        color="primary"
                                        v-if="info_invitation.required_documents.length > 0"
                                        :loading="loadingDocumentation"
                                        @click="showDocumentation()"
                                    >
                                        <v-icon left>attachment</v-icon>
                                        {{$t('view_attached_documents')}}
                                    </v-btn>
                                </v-card>
                            </v-flex>

                            <!-- Section 3: Host -->
                            <v-flex xs12 md6>
                                <!-- Host Info empresa B (Intermediaria) -->
                                <v-card flat class="blue-grey lighten-5 rounded-card pa-3 fill-height">
                                    <h3 class="subheading primary--text font-weight-bold text-xs-center mb-3">{{$t('info_anfitrion')}}</h3>
                                    <v-layout align-center column>
                                        <v-avatar size="100" class="elevation-4 avatar-border mb-3">
                                            <v-img :src="info_invitation.host_avatar || 'https://via.placeholder.com/100'"></v-img>
                                        </v-avatar>
                                        <div class="text-xs-center">
                                            <div class="subheading font-weight-bold">{{ info_invitation.host_first_name }} {{ info_invitation.host_last_name }}</div>
                                            <div class="caption grey--text"><v-icon x-small class="mr-1">phone</v-icon>{{ info_invitation.host_phone }}</div>
                                        </div>
                                    </v-layout>

                                    <!-- Anfitrión empresa A (Origen) — solo se muestra en flujo A→B→C -->
                                    <template v-if="info_invitation.host_a_first_name || info_invitation.host_a_last_name">
                                        <v-divider class="my-3"></v-divider>
                                        <div class="caption font-weight-bold blue-grey--text text-uppercase mb-2 text-xs-center">
                                            <v-icon x-small class="mr-1" color="orange darken-2">business</v-icon>
                                            Anfitrión Empresa Origen
                                        </div>
                                        <v-layout align-center column>
                                            <v-avatar size="72" class="elevation-3 mb-2" style="border: 2px solid #fb8c00;">
                                                <v-img :src="info_invitation.host_a_avatar || 'https://via.placeholder.com/72'"></v-img>
                                            </v-avatar>
                                            <div class="text-xs-center">
                                                <div class="body-2 font-weight-bold">{{ info_invitation.host_a_first_name }} {{ info_invitation.host_a_last_name }}</div>
                                                <div class="caption grey--text"><v-icon x-small class="mr-1">phone</v-icon>{{ info_invitation.host_a_phone }}</div>
                                            </div>
                                        </v-layout>
                                    </template>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4 bg-muted">
                    <v-layout align-end justify-center row wrap>
                        <v-flex shrink class="mx-2 my-1">
                            <v-btn
                                    large
                                    depressed
                                    class="rounded-btn premium-btn-primary ma-0"
                                    color="primary"
                                    @click="closeModal"
                            >
                                <v-icon left>close</v-icon>
                                {{ $t('cerrar')}}
                            </v-btn>
                        </v-flex>
                        <v-flex
                            v-if="!info_invitation.arrival_registered && (info_invitation.supervisor_authorization === false && info_invitation.authorization_attempts < 2)"
                            shrink
                            class="mx-2 my-1"
                        >
                            <v-layout column align-center>
                                <v-chip
                                    small
                                    color="orange darken-2"
                                    outline
                                    class="mb-2 font-weight-bold"
                                >
                                    <v-icon left x-small>info</v-icon>
                                    {{ 2 - info_invitation.authorization_attempts }} {{ 2 - info_invitation.authorization_attempts === 1 ? 'intento disponible' : 'intentos disponibles' }}
                                </v-chip>

                                <v-btn
                                    large
                                    depressed
                                    class="rounded-btn premium-btn-primary ma-0"
                                    color="primary"
                                    :loading="loading"
                                    :disabled="timerActive"
                                    @click="notificar_supervisor_acceso()"
                                >
                                    <v-icon left>notifications_active</v-icon>
                                    {{ timerActive ? 'Reintentar en ' + countdown + 's' : 'Notificar acceso al supervisor de embarque' }}
                                </v-btn>
                            </v-layout>
                        </v-flex>
                        <v-flex
                            v-if="!info_invitation.arrival_registered && (info_invitation.supervisor_authorization === false && info_invitation.authorization_attempts < 2)"
                            shrink
                            class="mx-1 my-1"
                        >
                            <v-btn
                                large
                                depressed
                                class="rounded-btn ma-0"
                                color="info"
                                :loading="loading"
                                @click="qr_code !== '' ? get_invitation() : get_invitation_manual()"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-flex>

                        <v-flex
                            v-if="!info_invitation.arrival_registered && info_invitation.confirmed && !info_invitation.canceled && info_invitation.window_status !== 'SALA_ESPERA'"
                            shrink
                            class="mx-2 my-1"
                        >
                            <v-btn
                                    large
                                    depressed
                                    class="rounded-btn premium-btn-warning ma-0"
                                    color="warning"
                                    :loading="loading"
                                    @click="dialogWaitingRoom = true"
                            >
                                <v-icon left>hourglass_empty</v-icon>
                                Enviar a sala de espera
                            </v-btn>
                        </v-flex>

                        <v-flex
                            v-if="!info_invitation.arrival_registered && info_invitation.window_status === 'SALA_ESPERA' && !info_invitation.supervisor_authorization"
                            shrink
                            class="mx-2 my-1"
                        >
                            <v-btn
                                    large
                                    depressed
                                    class="rounded-btn premium-btn-info ma-0"
                                    color="info"
                                    :loading="loading"
                                    @click="release_from_waiting_room"
                            >
                                <v-icon left>exit_to_app</v-icon>
                                Quitar de sala de espera
                            </v-btn>
                        </v-flex>

                        <v-flex
                            v-if="!info_invitation.arrival_registered && (info_invitation.window_status !== 'SALA_ESPERA' || (info_invitation.window_status === 'SALA_ESPERA' && info_invitation.supervisor_authorization)) && (info_invitation.supervisor_authorization === true || info_invitation.authorization_attempts === 2)"
                            shrink
                            class="mx-2 my-1"
                        >
                            <v-btn
                                    large
                                    depressed
                                    class="rounded-btn premium-btn-success ma-0"
                                    color="success"
                                    :loading="loading"
                                    @click="registrar_arribo(info_invitation.id)"
                            >
                                <v-icon left>check_circle</v-icon>
                                {{$t('Acceso')}}
                            </v-btn>
                        </v-flex>
                            


                        <v-flex
                            v-if="info_invitation.arrival_registered && !hasPendingWeighOutForExit()"
                            shrink
                            class="mx-2 my-1"
                        >
                            <v-btn
                                    large
                                    depressed
                                    class="rounded-btn premium-btn-success ma-0"
                                    color="success"
                                    :loading="loading"
                                    @click="registrar_salida(info_invitation.qr_code)"
                            >
                                <v-icon left>check_circle</v-icon>
                                {{$t('registrar_salida')}}
                            </v-btn>
                        </v-flex>

                        <v-flex
                            v-if="hasPendingWeighOutForExit()"
                            shrink
                            class="mx-2 my-1"
                        >
                            <v-btn
                                    large
                                    depressed
                                    class="rounded-btn premium-btn-warning ma-0"
                                    color="warning"
                                    @click="goToShipmentWeighQueue"
                            >
                                <v-icon left>scale</v-icon>
                                Registrar peso
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </div>
</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader'
    import ScaleWeighing from '@/views/ScaleWeighing.vue'
    import store from '@/store'
    import { mapState, mapGetters } from 'vuex'
    import jsPDF from 'jspdf'
    import axios from 'axios'

    export default {
        name: "AccessShipmentsModal",
        components: {
            QrcodeStream,
            ScaleWeighing
        },
                props: {
            qr_code: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                
                error: '',
                dialogUploadEvidence: false,
                evidenceForm: { file: null, fileName: '', description: '' },
                loadingUploadEvidence: false,
                dialogSendEvidence: false,
                evidenceEmails: [],
                loadingSendEvidence: false,
                info_invitation: [],
                dialog: false,
                valido: false,
                id_vigilante: 0,
                salida: false,
                entrada: false,
                estado: '',
                motivo_no_firma: '',
                comentarios_VE: '',
                errores: [],
                datos_coche: '',
                equipo_por_invitacion: [],
                data_access: [],
                dialog_inicio: false,
                casetas: [],
                caseta: 0,
                activar_camara: true,
                loading_gafete: false,
                a_qr_code: '',
                dialog_errores: false,
                errores_guard: '',
                head_color: '',
                band_gafete: false,
                dialogIP: false,
                ip: '127.0.0.1',
                loading: false,
                loadingCount: false,
                loadingCountIn: false,
                available_spaces: [],
                dialog_img: false,
                img_src: '',
                loadingDocumentation: false,
                ineFront: {
                    "id": 1000,
                    "name": "INE Frente",
                    "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg"
                },
                ineBack: {
                    "id": 1001,
                    "name": "INE Reverso",
                    "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg"
                },
                dialogDocumentos: false,
                missingDocumentations: [],
                dialogShowDocument: false,
                fileUrl: '',
                isPdf: false,
                access_data: null,
                countdown: 30,
                timerActive: false,
                timerInterval: null,
                dialogWaitingRoom: false,
                waitingRoomReason: '',
                loadingWaitingRoom: false,
                // CAV Module Properties
                isCavActive: false,
                shipping_window_id: null,
                weighInDone: false,
                weighOutDone: false,
                weighInResult: null,
                weighOutResult: null,
                dialogWeighIn: false,
                dialogWeighOut: false,
                loadingWeighIn: false,
                loadingWeighOut: false,
                formWeighIn: {
                    weight_kg: null,
                    scale_number: '',
                    vehicle_plate: '',
                    vehicle_type: '',
                    vehicle_economic_number: '',
                    driver_name: '',
                    guard_notes: ''
                },
                formWeighOut: {
                    weight_kg: null,
                    scale_number: '',
                    guard_notes: ''
                },
                cav_print_url: null,
                cav_ready_to_print: false
            }
        },
        created: function(){
            this.get_casetas()
            if(localStorage.getItem('id_caseta') === null){
                this.dialog_inicio = true
            }
            if(localStorage.getItem('dirIP') === null){
                this.ip = "127.0.0.1"
            } else {
                this.ip = localStorage.getItem('dirIP')
            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['caseta_vigilante'])
        },
        beforeDestroy() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval)
            }
        },
                mounted() {
            if (this.qr_code && this.qr_code !== '') {
                this.get_invitation()
            }
        },
        methods: {
            closeModal() {
                this.dialog = false;
                this.activar_camara = true;
                this.a_qr_code = '';
                // Resetear estado CAV
                this.weighInDone = false;
                this.weighOutDone = false;
                this.weighInResult = null;
                this.weighOutResult = null;
                this.isCavActive = false;
                this.shipping_window_id = null;
                this.cav_print_url = null;
                this.cav_ready_to_print = false;
                // Resetear formularios
                this.formWeighIn = {
                    weight_kg: null,
                    scale_number: '',
                    vehicle_plate: '',
                    vehicle_type: '',
                    vehicle_economic_number: '',
                    driver_name: '',
                    guard_notes: ''
                };
                this.formWeighOut = {
                    weight_kg: null,
                    scale_number: '',
                    guard_notes: ''
                };
                this.$emit('close');
            },
            closeAfterAccess() {
                this.dialog_errores = false;
                this.errores_guard = '';
                this.band_gafete = false;
                this.activar_camara = false;
                this.dialog = false;
                this.a_qr_code = '';
                this.entrada = false;
                this.salida = false;
                this.cav_print_url = null;
                this.cav_ready_to_print = false;
                this.$emit('close');
            },
            openDialog(fileUrl) {
                // 🔧 Ajusta esta ruta a tu estructura de archivos
                this.isPdf = fileUrl.toLowerCase().endsWith('.pdf')
                this.fileUrl = fileUrl
                this.dialogShowDocument = true
            },
            showDocumentation() {
                this.loadingDocumentation = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get-documents-by-user/' + this.info_invitation.guest_id + '/',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                axios(config)
                    .then(response => {
                        console.log(response.data)
                        this.missingDocumentations = this.compareDocumentation(this.info_invitation.required_documents, response.data)
                        this.loadingDocumentation = false
                    })
                    .catch(error => {
                        this.loadingDocumentation = false
                        console.log(error)
                    })
            },
            compareDocumentation(documentationsByInvitation, documentationsByUser) {
                console.log('Empieza a comparar documentaciones')
                let missingDocumentations = []
                // Compare the two sets of documentation
                for(let i = 0; i < documentationsByInvitation.length; i++) {
                    let band = false
                    for(let j = 0; j < documentationsByUser.length; j++) {
                        if(documentationsByInvitation[i].id === documentationsByUser[j].idDocumentation.id) {
                            band = true
                            missingDocumentations.push({
                                id: documentationsByUser[j].idDocumentation.id,
                                name: documentationsByUser[j].idDocumentation.name,
                                file: documentationsByUser[j].file
                            })
                        }
                    }
                    if(!band) {
                        missingDocumentations.push({
                            id: documentationsByInvitation[i].id,
                            name: documentationsByInvitation[i].name,
                            file: null
                        })
                    }
                }
                this.ineFront.file = this.info_invitation.guest_id_front
                this.ineBack.file = this.info_invitation.guest_id_back
                missingDocumentations.push(this.ineFront)
                missingDocumentations.push(this.ineBack)
                console.log('missingDocumentations = ', missingDocumentations)
                this.dialogDocumentos = true
                return missingDocumentations
            },
            get_current_date () {
              var today = new Date()
              var dd = today.getDate()
              var mm = today.getMonth() + 1
              var yyyy = today.getFullYear()

              if (dd < 10) {
                dd = '0' + dd
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              today = mm + '/' + dd + '/' + yyyy
              return today
            },
            get_current_date_yyyy_mm_dd () {
              var today = new Date()
              var dd = today.getDate()
              var mm = today.getMonth() + 1
              var yyyy = today.getFullYear()
              return yyyy + '-' + (mm < 10 ? '0' + mm : mm) + '-' + (dd < 10 ? '0' + dd : dd);
            },
            changeDirIP () {
                localStorage.setItem('dirIP', this.ip)
            },
            get_casetas: function(){
                this.$store.dispatch('security/FETCH_MY_CASETAS', store.getters.getToken)
                    .then(response => {
                        // Manejar múltiples formatos de respuesta
                        if (response && response.casetas && Array.isArray(response.casetas)) {
                            this.casetas = response.casetas
                        } else if (Array.isArray(response)) {
                            this.casetas = response
                        } else if (response && response.data && Array.isArray(response.data)) {
                            this.casetas = response.data
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            set_caseta: function(){
                if(this.caseta > 0){
                    localStorage.setItem('id_caseta', this.caseta)
                    this.dialog_inicio = false
                }
            },
            onDecode (result) {
                // this.qr_code = result // Avoid mutating prop
                this.$emit('decode', result)
                this.get_invitation()
            },
            hasPendingWeighOutForExit() {
                console.log();
                return !!(this.isCavActive && this.info_invitation && this.info_invitation.arrival_registered && this.info_invitation.requires_weigh_out && !this.info_invitation.has_weigh_out)
            },
            goToShipmentWeighQueue() {
                this.$router.push('/shipment_weigh_queue').catch(() => {})
            },
            get_invitation: function(){
                if (this.qr_code !== '') {
                    this.available_spaces = null
                    this.loading = true
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/shipments/guard/qr/' + this.qr_code + '/',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                    axios(config)
                        .then(response => {
                            this.loading = false
                            this.info_invitation = response.data
                            
                            // Extraer shipping_window_id e isCavActive
                            this.shipping_window_id = response.data.shipping_window_id || null
                            // Verificar is_cav_active (solo para guardias con roll === 9)
                            this.isCavActive = this.getProfile && this.getProfile.is_cav_active && this.getProfile.roll === 9 ? true : false
                            
                            // Sincronizar estado de pesadas con el servidor
                            this.weighInDone = response.data.has_weigh_in || false
                            this.weighOutDone = response.data.has_weigh_out || false

                            const todayStr = this.get_current_date_yyyy_mm_dd() 
                            const [day, month, year] = this.info_invitation.window_date.split('-')
                            const windowDateStr = `${year}-${month}-${day}` 

                       if (!this.info_invitation.arrival_registered && windowDateStr !== todayStr) {
                        this.valido = false
                        // Reset manual sin el $emit('close')
                        this.dialog = false
                        this.activar_camara = false
                        this.a_qr_code = ''
                        this.entrada = false
                        this.salida = false
                        // Ahora sí mostrar el error
                        this.errores_guard = '¡ACCESO NEGADO! La fecha programada para el embarque es ' + this.info_invitation.window_date + '.'
                        this.head_color = 'red display-1 text--primary'
                        this.dialog_errores = true
                        return
                    }

                            this.valido = true
                            this.is_access_in_out_both()
                        })
                        .catch(error => {
                            this.valido = false
                            this.loading = false
                            this.clear_without_activate_camera()
                            this.errores_guard =this.$t('mensaje_qr_no_valido')
                            this.head_color = 'red display-1 text--primary'
                            this.dialog_errores = true
                            console.log(error)
                        })
                }
            },
            get_invitation_manual: function(){
                this.available_spaces = null
                this.loading = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/guard/qr/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.info_invitation = response.data

                        // Extraer shipping_window_id e isCavActive
                        this.shipping_window_id = response.data.shipping_window_id || null
                        const profile = this.getProfile
                        // Verificar is_cav_active (solo para guardias con roll === 9)
                        this.isCavActive = this.getProfile && this.getProfile.is_cav_active && this.getProfile.roll === 9 ? true : false

                        // Sincronizar estado de pesadas con el servidor
                        this.weighInDone = response.data.has_weigh_in || false
                        this.weighOutDone = response.data.has_weigh_out || false

                        const todayStr = this.get_current_date_yyyy_mm_dd()
                        if (!this.info_invitation.arrival_registered && this.info_invitation.window_date !== todayStr) {
                            this.valido = false
                            this.clear_without_activate_camera()
                            this.errores_guard = '¡ACCESO NEGADO! La fecha programada para el embarque es ' + this.info_invitation.window_date + '.'
                            this.head_color = 'red display-1 text--primary'
                            this.dialog_errores = true
                            return
                        }

                        this.valido = true
                        this.is_access_in_out_both()
                    })
                    .catch(error => {
                        this.valido = false
                        this.loading = false
                        this.clear_without_activate_camera()
                        this.errores_guard =this.$t('mensaje_qr_no_valido')
                        this.head_color = 'red display-1 text--primary'
                        this.dialog_errores = true
                        console.log(error)
                    })

            },
            qr_is_valid: function(info_invitation){
                console.log(Object.keys(info_invitation).length)
                if (Object.keys(info_invitation).length > 0) {
                    this.valido = true
                    console.log("Valido")
                    this.is_access_in_out_both()
                }
                else{
                    this.valido = false
                    console.log("NO Valido")
                    //     this.$store.commit('snackbar_activate_true')
                    //     this.$store.commit('snackbar_change_color', 'error')
                    //     this.$store.commit('snackbar_change_message', this.$t('mensaje_qr_no_valido'))
                    //     setTimeout(this.clear, 3000)
                    this.clear_without_activate_camera()
                    this.errores_guard =this.$t('mensaje_qr_no_valido')
                    this.head_color = 'red display-1 text--primary'
                    this.dialog_errores = true
                }
            },
            is_access_in_out_both: function(){
                this.entrada = true
                this.salida = false
                this.dialog = true
                this.activar_camara = false
            },
            send_to_waiting_room() {
                this.loadingWaitingRoom = true;
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/guard/waiting-room/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        qr_code: this.info_invitation.qr_code || this.qr_code || this.a_qr_code,
                        reason: this.waitingRoomReason
                    }
                };
                axios(config)
                    .then(response => {
                        this.loadingWaitingRoom = false;
                        this.dialogWaitingRoom = false;
                        this.waitingRoomReason = '';
                        this.errores_guard = 'Enviado a sala de espera exitosamente';
                        this.head_color = 'green display-1 text--primary';
                        this.dialog_errores = true;
                        
                        if (this.qr_code !== '') {
                            this.get_invitation();
                        } else if(this.a_qr_code !== '') {
                            this.get_invitation_manual();
                        }
                    })
                    .catch(error => {
                        this.loadingWaitingRoom = false;
                        this.errores_guard = error.response && error.response.data && error.response.data.error ? error.response.data.error : 'Ocurrió un error al procesar el envío a sala de espera';
                        this.head_color = 'red display-1 text--primary';
                        this.dialog_errores = true;
                    });
            },
            release_from_waiting_room(cancel = false) {
                this.loading = true;
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/guard/waiting-room/release/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        qr_code: this.info_invitation.qr_code || this.qr_code || this.a_qr_code,
                        cancel: cancel
                    }
                };
                axios(config)
                    .then(response => {
                        this.access_data = response.data;
                        this.loading = false;
                        
                        this.errores_guard = cancel ? 'Se ha retirado de sala de espera exitosamente' : 'Liberado de sala de espera exitosamente. Aguarda autorización del supervisor';
                        this.head_color = 'green display-1 text--primary';
                        this.dialog_errores = true;
                        
                        if (this.qr_code !== '') {
                            this.get_invitation();
                        } else if(this.a_qr_code !== '') {
                            this.get_invitation_manual();
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.errores_guard = error.response && error.response.data && error.response.data.error ? error.response.data.error : 'Ocurrió un error al liberar de sala de espera';
                        this.head_color = 'red display-1 text--primary';
                        this.dialog_errores = true;
                    });
            },
            registrar_arribo: function(id_shipment){
                // OPCIÓN A: Si CAV activo y pesada no hecha, interceptar y mostrar diálogo
                if (this.isCavActive && !this.weighInDone) {
                    // Pre-llenar driver_name con datos conocidos
                    this.formWeighIn.driver_name = this.info_invitation.guest_first_name + ' ' + this.info_invitation.guest_last_name
                    this.formWeighIn.vehicle_plate = this.info_invitation.vehicle_plate || ''
                    this.formWeighIn.vehicle_type = this.info_invitation.transport_type || ''
                    this.dialogWeighIn = true
                    return
                }
                
                // Proceder con registro de arribo
                this.loading = true
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/guard/register-entry/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        qr_code: this.qr_code,
                        vehicle_plate: this.info_invitation.vehicle_plate || 'UNKNOWN',
                        driver_name: this.info_invitation.guest_first_name + ' ' + this.info_invitation.guest_last_name
                    }
                }
                axios(config)
                    .then(response => {
                        this.access_data = response.data
                        this.loading = false
                        this.dialog = false
                        this.entrada = false
                        this.salida = false
                        this.band_gafete = true
                        this.errores_guard = this.$t('mensaje_alta_arribo')
                        this.head_color = 'green display-1 text--primary'
                        this.dialog_errores = true
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_arribo'))
                        // Mantener el modal abierto para permitir imprimir el gafete.
                    })
                    .catch(error => {
                        this.loading = false
                        
                        // OPCIÓN B: Fallback reactivo - si error por falta de pesada
                        if (error.response && error.response.data && error.response.data.code === 'WEIGH_IN_REQUIRED') {
                            this.formWeighIn.driver_name = this.info_invitation.guest_first_name + ' ' + this.info_invitation.guest_last_name
                            this.formWeighIn.vehicle_plate = this.info_invitation.vehicle_plate || ''
                            this.formWeighIn.vehicle_type = this.info_invitation.transport_type || ''
                            this.dialogWeighIn = true
                            // Marcar CAV activo solo si el rol es 9
                            this.isCavActive = this.getProfile && this.getProfile.roll === 9 ? true : false
                            return
                        }
                        
                        this.errores = error.response.data
                        this.errores_guard = error.response.data.error
                        this.head_color = 'red display-1 text--primary'
                        this.dialog_errores = true
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', error.response.data.error)
                        setTimeout(this.clear, 3000);
                    })
            },
            openImage(src) {
                if (src) {
                    this.img_src = src
                    this.dialog_img = true
                }
            },
            sendDataWebServer (qrCode) {
                const config = {
                    method: 'post',
                    url: 'http://' + localStorage.getItem('dirIP') + '/set_data',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        qr_code: qrCode,
                        area: this.info_invitation.areaName
                    }
                }
                axios(config)
                    .then(response => {
                        console.log('Datos enviados al Web Server Correctamente.')
                        console.log(response)
                    })
                    .catch(error => {
                        console.log('Error del Web Server.')
                        console.log(error.response.data)
                    })
            },
            registrar_salida (qr_code){
                // Si el servidor indica que se requiere pesaje de salida y aún no se ha realizado
                if (this.isCavActive && this.info_invitation.requires_weigh_out && !this.weighOutDone) {
                    this.dialogWeighOut = true
                    return
                }
                
                // Proceder con registro de salida
                this.loading = true
                console.log(qr_code)
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/guard/register-exit/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        qr_code: qr_code
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.cav_print_url = response.data.cav_print_url || null
                        this.cav_ready_to_print = response.data.cav_ready_to_print || false

                        this.head_color = 'green display-1 text--primary'
                        this.errores_guard = this.$t('mensaje_alta_acceso_out')

                        if (this.isCavActive && this.cav_ready_to_print && this.cav_print_url) {
                            this.errores_guard += '\n\nCAV listo. Presiona Imprimir CAV para obtener el comprobante.'
                            this.openCavPrintUrl()
                        } else if (this.isCavActive && this.cav_print_url) {
                            this.errores_guard += '\n\nPresiona Imprimir CAV para obtener el comprobante.'
                        }

                        this.dialog_errores = true
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_out'))

                        if (!this.isCavActive || !this.cav_print_url) {
                            setTimeout(this.clear, 3000);
                        }
                    })
                    .catch(error => {
                        this.loading = false
                        this.errores_guard = error.response && error.response.data && error.response.data.error ? error.response.data.error : 'Ocurrió un error al registrar la salida';
                        
                        // OPCIÓN B: Fallback reactivo - si error por falta de pesada
                        if (this.isCavActive && error.response && error.response.data && error.response.data.code === 'WEIGH_OUT_REQUIRED') {
                            this.dialogWeighOut = true
                            return
                        }
                        
                        this.head_color = 'red display-1 text--primary'
                        this.dialog_errores = true
                        if(error.response && error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data) {
                            this.errores = error.response.data
                        }
                    })

            },
            updateCount () {
                this.loadingCount = true
                const config2 = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config2)
                    .then(response2 => {
                        if (this.info_invitation.typeInv !== 2)
                            this.data_access = response2.data
                        else
                          if (response2.data.length > 1) {
                            this.data_access = response2.data
                            console.log('Datos Accesos Count = ', response2.data[0])
                            }
                          else
                            this.data_access = response2.data
                        this.loadingCount = false
                    })
                    .catch(error => {
                        this.loadingCount = false
                        console.log(error)
                    })
            },
            updateCountEntrada () {
                this.loadingCountIn = true
                const config2 = {
                    method: 'get',
                    url:  'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config2)
                    .then(response2 => {
                        if (this.info_invitation.typeInv !== 2)
                            this.info_invitation = response2.data
                        else
                          if (response2.data.length > 1) {
                            this.info_invitation = response2.data
                            console.log('Datos Invitacion Count = ', response2.data[0])
                            }
                          else
                            this.info_invitation = response2.data
                        this.loadingCountIn = false
                    })
                    .catch(error => {
                        this.loadingCountIn = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_firmar(){
                this.loading = true
                console.log('Avisar al Anfitrión que firme pase de Salida = ', this.data_access[0].id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifySignExitPass/' + this.data_access[0].id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        setTimeout(this.clear, 3000);
                        const config2 = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        axios(config2)
                            .then(response2 => {
                                console.log(response2.data)
                                if (this.info_invitation.typeInv !== 2)
                                    this.data_access = response2.data
                                else
                                  if (response2.data.length > 1) {
                                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                                    this.data_access = response2.data
                                  }
                                  else
                                    this.data_access = response2.data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_acceso(){
                this.loading = true
                console.log('Avisar al Anfitrión que autorize el acceso de su invitado= ', this.info_invitation.id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifyAuthorizedAccess/' + this.info_invitation.id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        setTimeout(this.clear, 3000);
                        const config2 = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        axios(config2)
                            .then(response2 => {
                                console.log(response2.data)
                                if (this.info_invitation.typeInv !== 2)
                                    this.info_invitation = response2.data
                                else
                                  if (response2.data.length > 1) {
                                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                                    this.info_invitation = response2.data
                                  }
                                  else
                                    this.info_invitation = response2.data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            startTimer() {
                this.timerActive = true
                this.countdown = 30
                this.timerInterval = setInterval(() => {
                    this.countdown--
                    if (this.countdown <= 0) {
                        clearInterval(this.timerInterval)
                        this.timerActive = false
                        this.countdown = 30
                        if (this.qr_code !== '') {
                            this.get_invitation()
                        } else {
                            this.get_invitation_manual()
                        }
                    }
                }, 1000)
            },
            notificar_supervisor_acceso(){
                this.loading = true
                console.log('Avisar al Supervisor que autorize el acceso del embarque = ', this.info_invitation.qr_code)
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/guard/request-authorization/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        qr_code: this.info_invitation.qr_code
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', 'Notificación enviada al supervisor')
                        setTimeout(this.clear, 3000);
                        this.startTimer()
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            async onInit (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERROR: Stream API is not supported in this browser"
                    }
                }
            },
            clear: function () {
                this.dialog = false
                this.$emit('close')
                this.a_qr_code = ''
                this.entrada = false
                this.salida = false
                this.activar_camara = true
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
            },
            clear_without_activate_camera: function () {
                this.dialog = false
                this.activar_camara = false
                this.$emit('close')
                this.a_qr_code = ''
                this.entrada = false
                this.salida = false
            },
            get_equipo_invitacion: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/equipo_seguridad/' + this.info_invitation.id + '/',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                axios(config)
                    .then(response => {
                        this.equipo_por_invitacion = response.data
                        console.log(this.equipo_por_invitacion)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            xOffset: function(pdf, text){
                return ((pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2) / 72.0)
            },
            getImgFromUrl(logo_url, callback) {
                var img = new Image();
                img.src = logo_url;
                img.onload = function () {
                    callback(img);
                };
            },
            getCompanyLogoUrl() {
                return this.info_invitation.company_logo
                    || this.info_invitation.logoEmpresa
                    || this.info_invitation.logo_empresa
                    || this.info_invitation.host_company_logo
                    || null
            },
            async loadImageAsDataUrl(imageUrl) {
                if (!imageUrl) return null
                try {
                    const response = await axios.get(imageUrl, { responseType: 'blob' })
                    return await new Promise(resolve => {
                        const reader = new FileReader()
                        reader.onloadend = () => resolve(reader.result)
                        reader.onerror = () => resolve(null)
                        reader.readAsDataURL(response.data)
                    })
                } catch (error) {
                    return null
                }
            },
            download_gafete_original: function(){
                this.loading_gafete = true
                console.log('Datos de la Invitación: ')
                console.log(this.info_invitation)
                // console.log(this.info_invitation)
                const toDataUrl = (url, callback) => {
                    const img = new Image();
                    img.crossOrigin = 'anonymous';
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.naturalWidth;
                        canvas.height = img.naturalHeight;
                        canvas.getContext('2d').drawImage(img, 0, 0);
                        callback(canvas.toDataURL('image/png'));
                    };
                    img.onerror = () => callback(null);
                    img.src = url;
                };

                toDataUrl(this.info_invitation.avatar, (myBase64) => {
                    var pdf = new jsPDF("portrait", "pt", "letter")
                    // Black square with rounded corners
                    pdf.setDrawColor(0)
                    pdf.setFillColor(255, 255, 255)
                    pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.empresa,
                        this.xOffset(pdf, this.info_invitation.empresa),
                        130)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Visitante'),
                        this.xOffset(pdf, this.$t('Visitante')),
                        145)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
                        this.xOffset(pdf, this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName) ,
                        160)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Anfitrion'),
                        this.xOffset(pdf, this.$t('Anfitrion')),
                        175)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
                        this.xOffset(pdf, this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
                        190)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Area'),
                        this.xOffset(pdf, this.$t('Area')),
                        205)
                    pdf.setTextColor(this.info_invitation.areaColor)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.areaName.toUpperCase(),
                        this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
                        220)
                    pdf.setTextColor('#000000')
                    pdf.text(this.$t('fecha_hora'),
                        this.xOffset(pdf, this.$t('fecha_hora')),
                        235)
                    pdf.setFontStyle("normal")
                    pdf.text(this.info_invitation.dateInv + ' ' + this.info_invitation.timeInv,
                        this.xOffset(pdf, this.info_invitation.dateInv + ' ' +  this.info_invitation.timeInv),
                        250)
                    pdf.setLineWidth(4.0)
                    pdf.setDrawColor(this.info_invitation.areaColor)
                    pdf.setFillColor('#FFFFFF')
                    pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
                    // console.log(myBase64); // myBase64 is the base64 string
                    pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
                    toDataUrl(this.info_invitation.logoEmpresa, (logo_guest) => {
                        pdf.addImage(logo_guest, 'WEBP', 190, 60, 50, 50);
                        this.getImgFromUrl(require('../../assets/intrare_logo.png'), function (logo_system,) {
                            pdf.addImage(logo_system, 'WEBP', 370, 60, 50, 50);
                            pdf.save('gafete.pdf')
                        });
                    });
                    this.loading_gafete = false
                });
            },
            download_gafete: async function(){
                this.loading_gafete = true
                console.log('Datos de la Invitación: ')
                console.log(this.info_invitation)
                
                const accessTime = this.access_data && this.access_data.access_time ? this.access_data.access_time : new Date().toLocaleTimeString();
                const loadingArea = this.access_data && this.access_data.loading_area ? this.access_data.loading_area : (this.info_invitation.loading_area_name || '');
                const guestNameOrigin = this.access_data && this.access_data.guest_name ? this.access_data.guest_name : (this.info_invitation.guest_first_name + ' ' + this.info_invitation.guest_last_name);
                const guestName = guestNameOrigin || '';

                // console.log(this.info_invitation)
                var pdf = new jsPDF('l', 'in', [432, 252])
                // Black square with rounded corners
                pdf.setDrawColor(0)
                pdf.setFontSize(9)
                pdf.text(this.$t('fecha_hora_acceso'),
                    4.0,
                    0.4)
                pdf.setLineWidth(0.02)
                pdf.line(4.0, 0.42, 5.8, 0.42)
                pdf.setFontStyle("normal")
                pdf.text(accessTime,
                    4.3,
                    0.65)
                pdf.setFontStyle("bold")
                pdf.text(loadingArea,
                    pdf.internal.pageSize.width - 0.4,
                    0.95,
                    null,
                    null,
                    'right')
                pdf.setFontSize(14)
                pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 1.32, 4.0, 1.32)
                pdf.setFontStyle("normal")
                pdf.text(this.$t('Visitante').toUpperCase(),
                    this.xOffset(pdf, this.$t('Visitante').toUpperCase()),
                    1.3)
                pdf.setFontStyle("bold")
                pdf.text(guestName,
                    this.xOffset(pdf, guestName),
                    1.75)
                pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 2.17, 4.0, 2.17)
                pdf.setFontStyle("normal")
                pdf.text(this.$t('Anfitrion').toUpperCase(),
                    this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()),
                    2.15)
                // En flujo A→B→C usamos el anfitrión de empresa A (responsable original);
                // en otros flujos usamos empresa B (host normal).
                const hostNameOrigin = (this.info_invitation.host_a_first_name || this.info_invitation.host_a_last_name)
                    ? `${this.info_invitation.host_a_first_name || ''} ${this.info_invitation.host_a_last_name || ''}`.trim()
                    : (this.info_invitation.host_first_name || this.info_invitation.host_last_name)
                        ? `${this.info_invitation.host_first_name || ''} ${this.info_invitation.host_last_name || ''}`.trim()
                        : (this.info_invitation.invited_by_name || this.info_invitation.creator_name || '');
                const hostNameToPrint = hostNameOrigin || '';
                pdf.setFontStyle("bold")
                pdf.text(hostNameToPrint,
                    this.xOffset(pdf, hostNameToPrint),
                    2.55)
                pdf.setTextColor('#000000')
                // Empresa (centrado, debajo del anfitrión)
                const companyName = this.info_invitation.company_name || ''
                pdf.setFontStyle("normal")
                pdf.setFontSize(9)
                pdf.text('EMPRESA',
                    this.xOffset(pdf, 'EMPRESA'),
                    3.05)
                pdf.setFontStyle("bold")
                pdf.setFontSize(9)
                pdf.text(companyName,
                    this.xOffset(pdf, companyName),
                    3.30)

                // Placa y tipo de transporte (lado derecho)
                const vehiclePlate = this.info_invitation.vehicle_plate || 'N/A'
                const transportType = this.info_invitation.transport_type || 'N/A'
                pdf.setFontStyle("normal")
                pdf.setFontSize(9)
                pdf.text('Placa: ' + vehiclePlate, 4.0, 1.30)
                pdf.text('Tipo: ' + transportType, 4.0, 1.60)

                // Logo empresa
                const companyLogoUrl = this.getCompanyLogoUrl()
                const logoDataUrl = await this.loadImageAsDataUrl(companyLogoUrl)
                if (logoDataUrl) {
                    pdf.addImage(logoDataUrl, 'PNG', 0.2, 0.15, 1.2, 0.85)
                }

                // Foto del invitado (lado izquierdo, debajo del logo)
                const guestAvatarUrl = this.info_invitation.guest_avatar || null
                const guestAvatarDataUrl = await this.loadImageAsDataUrl(guestAvatarUrl)
                if (guestAvatarDataUrl) {
                    pdf.addImage(guestAvatarDataUrl, 'PNG', 0.2, 1.15, 1.2, 1.4)
                }

                pdf.save('gafete.pdf')
                this.loading_gafete = false
            },
            openUploadEvidence() {
                this.dialogUploadEvidence = true;
                this.evidenceForm = { file: null, fileName: '', description: '' };
            },
            onFileChange(e) {
                const files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;
                this.evidenceForm.file = files[0];
                this.evidenceForm.fileName = files[0].name;
            },
            uploadEvidence() {
                if (!this.evidenceForm.file) {
                    alert('Selecciona un archivo');
                    return;
                }
                this.loadingUploadEvidence = true;
                
                const formData = new FormData();
                formData.append('shipment_id', this.info_invitation.id);
                formData.append('file_evidence', this.evidenceForm.file);
                formData.append('description', this.evidenceForm.description);

                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/shipment-load-evidences/',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: formData
                };

                axios(config)
                    .then(response => {
                        this.loadingUploadEvidence = false;
                        this.dialogUploadEvidence = false;
                        this.$store.commit('snackbar_activate_true');
                        this.$store.commit('snackbar_change_message', 'Evidencia subida correctamente');
                        setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        console.log(error);
                        this.loadingUploadEvidence = false;
                        this.$store.commit('snackbar_activate_true');
                        this.$store.commit('snackbar_change_message', 'Error al subir evidencia');
                        setTimeout(this.clear, 3000);
                    });
            },
            // CAV Module Methods
            onWeighInSave(weighData) {
                this.loadingWeighIn = true;
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/scale/weigh-in/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        shipping_window_id: this.shipping_window_id,
                        weight_kg: weighData.weight_kg,  // Peso inicial del vehículo
                        scale_number: weighData.scaleNumber,
                        vehicle_plate: this.info_invitation.vehicle_plate || 'UNKNOWN',
                        vehicle_type: this.info_invitation.transport_type || 'N/A',
                        vehicle_economic_number: this.info_invitation.vehicle_economic_number || '',
                        driver_name: this.info_invitation.guest_first_name + ' ' + this.info_invitation.guest_last_name,
                        guard_notes: ''
                    }
                };

                axios(config)
                    .then(response => {
                        this.loadingWeighIn = false;
                        this.weighInResult = response.data;
                        this.weighInDone = true;
                        this.dialogWeighIn = false;
                        
                        // Mostrar confirmación y proceder a registrar arribo
                        this.$store.commit('snackbar_activate_true');
                        this.$store.commit('snackbar_change_message', 'Pesada de entrada registrada correctamente');
                        
                        // Continuar con registrar_arribo
                        setTimeout(() => {
                            this.registrar_arribo(this.info_invitation.id);
                        }, 500);
                    })
                    .catch(error => {
                        this.loadingWeighIn = false;
                        const errorMsg = error.response && error.response.data && error.response.data.error 
                            ? error.response.data.error 
                            : 'Error al registrar pesada de entrada';
                        this.$store.commit('snackbar_activate_true');
                        this.$store.commit('snackbar_change_message', errorMsg);
                        console.log(error);
                    });
            },
            onWeighOutSave(weighData) {
                if (!this.isCavActive) {
                    this.$store.commit('snackbar_activate_true');
                    this.$store.commit('snackbar_change_message', 'El modulo CAV no esta activo para esta empresa');
                    return;
                }
                this.loadingWeighOut = true;
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/shipments/scale/weigh-out/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        shipping_window_id: this.shipping_window_id,
                        weight_kg: weighData.weight_kg,  // Peso final del vehículo
                        scale_number: weighData.scaleNumber,
                        guard_notes: ''
                    }
                };

                axios(config)
                    .then(response => {
                        this.loadingWeighOut = false;
                        this.weighOutResult = response.data;
                        this.weighOutDone = true;
                        
                        // Mostrar modal con resumen de pesos ANTES de cerrar
                        const netWeight = response.data.weight_net_kg;
                        const inWeight = response.data.weight_in_kg;
                        const outWeight = response.data.weight_out_kg;
                        
                        this.errores_guard = `Pesada de Salida Registrada\n\nPeso Entrada: ${inWeight.toLocaleString('es-MX')} kg\nPeso Salida: ${outWeight.toLocaleString('es-MX')} kg\n\n━━━━━━━━━━━━━━━━━━\nPeso Neto: ${netWeight.toLocaleString('es-MX')} kg`;
                        this.head_color = 'green display-1 text--primary';
                        this.dialog_errores = true;
                        
                        // Cerrar el diálogo de pesada
                        this.dialogWeighOut = false;
                        
                        // Continuar con registrar_salida después de mostrar el resumen
                        setTimeout(() => {
                            this.registrar_salida(this.qr_code);
                        }, 1000);
                    })
                    .catch(error => {
                        this.loadingWeighOut = false;
                        const responseData = error.response && error.response.data;
                        // Si ya existe una pesada de salida, marcarla como hecha y proceder
                        if (responseData && (responseData.code === 'WEIGH_OUT_EXISTS' || responseData.code === 'DUPLICATE_WEIGH_OUT')) {
                            this.weighOutDone = true;
                            this.dialogWeighOut = false;
                            this.$store.commit('snackbar_activate_true');
                            this.$store.commit('snackbar_change_message', 'Ya existe una pesada de salida registrada. Procediendo...');
                            setTimeout(() => { this.registrar_salida(this.qr_code) }, 500);
                            return;
                        }
                        const errorMsg = responseData && responseData.error
                            ? responseData.error
                            : 'Error al registrar pesada de salida';
                        this.$store.commit('snackbar_activate_true');
                        this.$store.commit('snackbar_change_message', errorMsg);
                        console.log(error);
                    });
            },
            getFilenameFromDisposition(disposition, fallback = 'CAV.pdf') {
                if (!disposition) return fallback
                const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
                if (utf8Match && utf8Match[1]) {
                    return decodeURIComponent(utf8Match[1])
                }
                const asciiMatch = disposition.match(/filename="?([^";]+)"?/i)
                if (asciiMatch && asciiMatch[1]) {
                    return asciiMatch[1]
                }
                return fallback
            },
            async parseBlobError(blobData) {
                try {
                    const text = await blobData.text()
                    return JSON.parse(text)
                } catch (e) {
                    return null
                }
            },
            async openCavPrintUrl() {
                if (!this.isCavActive) {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', 'El modulo CAV no esta activo para esta empresa')
                    return
                }
                if (!this.cav_print_url) return

                this.loading = true
                try {
                    const response = await axios({
                        method: 'get',
                        url: this.cav_print_url,
                        headers: {
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        responseType: 'blob'
                    })

                    const disposition = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition'])
                    const fallbackName = this.shipping_window_id ? `CAV-${this.shipping_window_id}.pdf` : 'CAV.pdf'
                    const fileName = this.getFilenameFromDisposition(disposition, fallbackName)

                    const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', fileName)
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    URL.revokeObjectURL(url)

                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', 'PDF CAV descargado correctamente')
                } catch (error) {
                    const status = error.response && error.response.status
                    const parsedError = error.response && error.response.data
                        ? await this.parseBlobError(error.response.data)
                        : null

                    let errorMsg = 'Error al descargar el PDF del CAV'
                    if (status === 400 && parsedError) {
                        const missing = []
                        if (!parsedError.has_weigh_in) missing.push('- Pesada de entrada')
                        if (!parsedError.has_weigh_out) missing.push('- Pesada de salida')
                        errorMsg = missing.length > 0
                            ? `No se puede generar el PDF. Faltan:\n${missing.join('\n')}`
                            : (parsedError.error || errorMsg)
                    } else if (status === 403) {
                        errorMsg = parsedError && parsedError.error ? parsedError.error : 'CAV no esta activo para esta empresa'
                    } else if (status === 404) {
                        errorMsg = parsedError && parsedError.error ? parsedError.error : 'No existe el embarque para generar CAV'
                    } else if ((status === 500 || status === 501) && parsedError && parsedError.cav_data) {
                        errorMsg = 'No se pudo generar el PDF en servidor, pero el CAV tiene datos disponibles (cav_data)'
                    } else if (parsedError && parsedError.error) {
                        errorMsg = parsedError.error
                    }

                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', errorMsg)
                    console.log(error)
                } finally {
                    this.loading = false
                }
            },
            downloadCavPdf() {
                if (!this.shipping_window_id) {
                    this.$store.commit('snackbar_activate_true');
                    this.$store.commit('snackbar_change_message', 'No se puede descargar el PDF. ID de envío no disponible.');
                    return;
                }

                this.loading = true;
                axios({
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/scale/cav/' + this.shipping_window_id + '/pdf/',
                    headers: {
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    responseType: 'blob'
                })
                    .then(response => {
                        this.loading = false;
                        
                        // Crear blob y descargar
                        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `CAV-${this.shipping_window_id}.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        URL.revokeObjectURL(url);
                        
                        this.$store.commit('snackbar_activate_true');
                        this.$store.commit('snackbar_change_message', 'PDF descargado correctamente');
                    })
                    .catch(error => {
                        this.loading = false;
                        
                        // Intentar extraer información de qué pesadas faltan
                        if (error.response && error.response.data && error.response.status === 400) {
                            const data = error.response.data;
                            const missing = [];
                            if (!data.has_weigh_in) missing.push('- Pesada de entrada');
                            if (!data.has_weigh_out) missing.push('- Pesada de salida');
                            
                            const errorMsg = missing.length > 0 
                                ? `No se puede generar el PDF. Faltan: \n${missing.join('\n')}`
                                : 'Error al generar el PDF';
                            
                            this.$store.commit('snackbar_activate_true');
                            this.$store.commit('snackbar_change_message', errorMsg);
                        } else {
                            const errorMsg = error.response && error.response.data && error.response.data.error 
                                ? error.response.data.error 
                                : 'Error al descargar el PDF';
                            this.$store.commit('snackbar_activate_true');
                            this.$store.commit('snackbar_change_message', errorMsg);
                        }
                        console.log(error);
                    });
            }
        }
    }
</script>